import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import TradeSummary from 'src/enosikit/components/TradeSummary';
import Loading from 'src/components/Loading';

import { normaliseTradeData } from './helpers/propertyShowTradeSummary';

class PropertyShowTradeSummary extends React.Component {
  static renderSummaryCard(type, data, title, hasCounterfactual, summaryClassName) {
    if (!data) {
      return null;
    }
    return (
      <TradeSummary
        category={type}
        data={data}
        hasCounterfactual={hasCounterfactual}
        summaryClassName={summaryClassName}
        title={title}
      />
    );
  }

  render() {
    if (this.error) {
      return <div><FormattedMessage id="error.title" defaultMessage="Error!" /></div>;
    }
    const { mainData } = this.props;

    if (!mainData) {
      return <Loading />;
    }

    const { hasCounterfactual, property } = mainData;
    const { title } = property;

    const summaryData = normaliseTradeData(mainData);

    return (
      <div className="trade-summaries mb-4 row row-cols-1 row-cols-sm-2">
        {PropertyShowTradeSummary.renderSummaryCard('imports', summaryData.buy, title, hasCounterfactual)}
        {PropertyShowTradeSummary.renderSummaryCard('exports', summaryData.sell, title, hasCounterfactual)}
      </div>
    );
  }
}

PropertyShowTradeSummary.propTypes = {
  mainData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default PropertyShowTradeSummary;
